module.exports = __webpack_public_path__ + "img/imagen2.692dc656.png";